// @ts-nocheck
import log from 'js-logger';
import $ from 'jquery';

export class SoundMeter {
    constructor(sessionId) {
        let audioContext = null;
        try {
            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            audioContext = new AudioContext();
        } catch(e) {
            log.warn('LEGO [SoundMeter] AudioContext() LocalAudio not available... its fine.');
        }
        if (audioContext == null) return null;
        this.context = audioContext;
        this.source = null;

        this.sessionId = sessionId;

        this.captureInterval = null;
        this.levelsInterval = null;
        this.networkInterval = null;
        this.startTime = 0;

        this.ReceiveBitRateChart = null;
        this.ReceiveBitRate = [];
        this.ReceivePacketRateChart = null;
        this.ReceivePacketRate = [];
        this.ReceivePacketLossChart = null;
        this.ReceivePacketLoss = [];
        this.ReceiveJitterChart = null;
        this.ReceiveJitter = [];
        this.ReceiveLevelsChart = null;
        this.ReceiveLevels = [];
        this.SendBitRateChart = null;
        this.SendBitRate = [];
        this.SendPacketRateChart = null;
        this.SendPacketRate = [];
        this.instant = 0;
        this.AnalyserNode = this.context.createAnalyser();
        this.AnalyserNode.minDecibels = -90;
        this.AnalyserNode.maxDecibels = -10;
        this.AnalyserNode.smoothingTimeConstant = 0.85;
    }
    connectToSource(stream, callback) {
        log.info('LEGO [SoundMeter]  connecting...', new Date());
        try {
            this.source = this.context.createMediaStreamSource(stream);
            this.source.connect(this.AnalyserNode);
            this._start();
            callback(null);
        } catch(e) {
            log.error(e); // Probably not audio track
            callback(e);
        }
    }
    _start(){
        let self = this;
        self.started = new Date();
        self.instant = 0;
        self.AnalyserNode.fftSize = 32; // 32, 64, 128, 256, 512, 1024, 2048, 4096, 8192, 16384, and 32768. Defaults to 2048
        self.dataArray = new Uint8Array(self.AnalyserNode.frequencyBinCount);

        this.captureInterval = window.setInterval(function(){
            self.AnalyserNode.getByteFrequencyData(self.dataArray); // Populate array with data from 0-255

            // Just take the maximum value of this data
            self.instant = 0;
            for(var d = 0; d < self.dataArray.length; d++) {
                if(self.dataArray[d] > self.instant) self.instant = self.dataArray[d];
            }
            //log.info('LEGO [SoundMeter] Start ...', self.instant, self.started);
        }, 1);
        log.info('LEGO [SoundMeter] Start ...');
    }
    stop() {
        return new Promise((resolve) => {
            log.info('LEGO [SoundMeter] Disconnecting ...', this.captureInterval, this.levelsInterval, this.networkInterval);
            window.clearInterval(this.captureInterval);
            this.captureInterval = null;
            window.clearInterval(this.levelsInterval);
            this.levelsInterval = null;
            window.clearInterval(this.networkInterval);
            this.networkInterval = null;
            try {
                this.source.disconnect();
            } catch (e) {
                log.info('LEGO [SoundMeter] Error source.disconnect:', e)
            }
            this.source = null;
            try {
                this.AnalyserNode.disconnect();
            } catch (e) {
                log.info('LEGO [SoundMeter] Error AnalyserNode.disconnect:', e)
            }
            this.AnalyserNode = null;
            try {
                this.context.close();
            } catch (e) {
                log.info('LEGO [SoundMeter] Error context.close:', e)
            }
            this.context = null;

            resolve('');
        });
    }
}

export function StartLocalMonitoring(session) {
    return new Promise((resolve) => {
        log.info('LEGO [StartMonitoring] Init ... ');

        // Create local SoundMeter
        let soundMeter = new SoundMeter(session.id);
        if (soundMeter == null) {
            log.warn('LEGO [StartMonitoring] AudioContext() LocalAudio not available... its fine.')
            return null;
        }

        // Ready the getStats request
        let localAudioStream = new MediaStream();
        let audioSender = null;
        let pc = session.sessionDescriptionHandler.peerConnection;
        pc.getSenders().forEach(function (RTCRtpSender) {
            if (RTCRtpSender.track && RTCRtpSender.track.kind == 'audio') {
                if (audioSender == null) {
                    log.info('LEGO [StartMonitoring] Adding Track to Monitor: ', RTCRtpSender.track.label);
                    localAudioStream.addTrack(RTCRtpSender.track);
                    audioSender = RTCRtpSender;
                } else {
                    log.info('LEGO [StartMonitoring] Found another Track, but audioSender not null');
                    log.info(RTCRtpSender);
                    log.info(RTCRtpSender.track);
                }
            }
        });

        soundMeter.startTime = new Date();
        soundMeter.connectToSource(localAudioStream, function (e) {
            if (e != null) return;
            log.info('LEGO [StartMonitoring] SoundMeter for LocalAudio Connected, displaying levels');
            soundMeter.levelsInterval = window.setInterval(function () {
                // Calculate Levels (0 - 255)
                let instPercent = (soundMeter.instant / 255) * 100;
                $('#micMeter').css('height', instPercent.toFixed(2) + '%');
            }, 50);
        });
        resolve(soundMeter);
    });
}

export function MeterSettingsOutput(audioStream, objectId, direction, interval){
    var soundMeter = new SoundMeter(null, null);
    soundMeter.startTime = Date.now();
    soundMeter.connectToSource(audioStream, function (e) {
        if (e != null) return;

        log.info('LEGO [MeterSettingsOutput] SoundMeter Connected, displaying levels to:'+ objectId);
        soundMeter.levelsInterval = window.setInterval(function () {
            // Calculate Levels (0 - 255)
            var instPercent = (soundMeter.instant/255) * 100;
            $('#'+ objectId).css(direction, instPercent.toFixed(2) +'%');
        }, interval);
    });

    return soundMeter;
}

export function StartRemoteMonitoring(session) {
    return new Promise((resolve) => {
        log.info('LEGO [StartRemoteMonitoring] Creating RemoteAudio AudioContext on Line');

        // Create local SoundMeter
        let soundMeter = new SoundMeter(session.id);
        if(soundMeter == null){
            log.warn('LEGO [StartRemoteMonitoring] AudioContext() RemoteAudio not available... it fine.');
            return null;
        }

        // Ready the getStats request
        let remoteAudioStream = new MediaStream();
        let audioReceiver = null;
        let pc = session.sessionDescriptionHandler.peerConnection;
        pc.getReceivers().forEach(function (RTCRtpReceiver) {
            if(RTCRtpReceiver.track && RTCRtpReceiver.track.kind == 'audio'){
                if(audioReceiver == null) {
                    remoteAudioStream.addTrack(RTCRtpReceiver.track);
                    audioReceiver = RTCRtpReceiver;
                }
                else {
                    log.info('LEGO [StartRemoteMonitoring] Found another Track, but audioReceiver not null');
                    log.info(RTCRtpReceiver);
                    log.info(RTCRtpReceiver.track);
                }
            }
        });

        // Setup Sound Metter
        soundMeter.startTime = Date.now();

        // Connect to Source
        soundMeter.connectToSource(remoteAudioStream, function (e) {
            if (e != null) return;

            // Create remote SoundMeter
            log.info('LEGO [StartRemoteMonitoring] SoundMeter for RemoteAudio Connected, displaying levels for Line');
            soundMeter.levelsInterval = window.setInterval(function () {
                // Calculate Levels (0 - 255)
                let instPercent = (soundMeter.instant/255) * 100;
                $('#speakerMeter').css('height', instPercent.toFixed(2) +'%');
            }, 50);
            soundMeter.networkInterval = null;
        });
        resolve(soundMeter);
    });
}
